import { ThemeProvider, extendTheme } from '@chakra-ui/react';
import { brandThemes, useThemeMode } from 'pixelize-design-library';
import type { ReactNode } from 'react';

import { authBrandPalette } from './authBrandPalette';

/** Scopes the auth-pages brand to auth pages only — the rest of the app keeps its own brand. */
export function AuthThemeScope({ children }: { children: ReactNode }) {
  const { resolvedMode } = useThemeMode();
  const theme = extendTheme(brandThemes.skyline[resolvedMode], {
    colors: authBrandPalette[resolvedMode]
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
